import { Link } from 'react-router-dom';
import { getFeaturedArticles } from '@/mocks/articles';

export default function FeaturedGrid() {
  const featured = getFeaturedArticles();

  return (
    <section className="w-full max-w-[1400px] mx-auto px-6 md:px-10 py-16 md:py-20">
      <div className="flex flex-col md:flex-row md:items-end justify-between mb-10">
        <div>
          <h2 className="font-heading text-3xl md:text-4xl font-black text-foreground-50 mb-2">
            今日<strong className="text-primary-400">重磅</strong>
          </h2>
          <p className="text-foreground-500 text-sm">实时追踪全网最具爆炸性的黑料内容</p>
        </div>
        <Link
          to="/category/wanghong-tafang"
          className="mt-3 md:mt-0 text-foreground-400 hover:text-primary-400 text-sm flex items-center space-x-1 transition-colors whitespace-nowrap"
        >
          <span>查看全部</span>
          <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
        </Link>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
        {featured.slice(0, 6).map((article) => (
          <Link
            key={article.id}
            to={`/article/${article.slug}`}
            className="group bg-background-100 rounded-xl overflow-hidden border border-background-200/60 hover:border-primary-500/30 transition-all duration-300 cursor-pointer"
          >
            <div className="relative overflow-hidden">
              <img
                src={article.imageUrl}
                alt={article.title}
                title={article.title}
                className="w-full h-48 object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-background-100 via-transparent to-transparent"></div>
              <span className="absolute top-3 left-3 px-2.5 py-1 bg-primary-500/90 text-background-50 text-xs font-medium rounded-md flex items-center space-x-1">
                <span className="w-1.5 h-1.5 rounded-full bg-background-50"></span>
                <span>{article.category}</span>
              </span>
            </div>
            <div className="p-4">
              <h3 className="text-foreground-100 text-sm md:text-base font-semibold leading-snug mb-2 group-hover:text-primary-400 transition-colors line-clamp-2">
                {article.title}
              </h3>
              <p className="text-foreground-500 text-xs leading-relaxed line-clamp-2 mb-3">
                {article.summary}
              </p>
              <div className="flex items-center justify-between text-foreground-600 text-xs">
                <span>{article.date}</span>
                <div className="flex items-center space-x-3">
                  <span className="flex items-center space-x-1">
                    <i className="ri-eye-line w-3 h-3 flex items-center justify-center"></i>
                    <span>{article.views >= 1000 ? `${(article.views / 1000).toFixed(0)}k` : article.views}</span>
                  </span>
                  <span className="flex items-center space-x-1">
                    <i className="ri-chat-1-line w-3 h-3 flex items-center justify-center"></i>
                    <span>{article.comments >= 1000 ? `${(article.comments / 1000).toFixed(0)}k` : article.comments}</span>
                  </span>
                </div>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}